import { put } from "../../service/api";

const UpdatePos = async (pos) => {
  try {
    const response = await put(`/pos/${pos.id}`, pos);
    return response;
  } catch (error) {
    console.error("Error UpdatePos:", error);
    throw error;
  }
};

export default UpdatePos;
